const notifySingleAlert = (message, values) => {
  const event = new CustomEvent('notify', {
    bubbles: true,
    detail: {
      color: 'error',
      text: message,
      variables: values,
    },
  })
  document.dispatchEvent(event)
}

const notifyManyAlerts = (messages, values) => {
  const event = new CustomEvent('notify-array', {
    bubbles: true,
    detail: {
      color: 'error',
      text: messages,
      variables: values,
    },
  })
  document.dispatchEvent(event)
}

export { notifySingleAlert, notifyManyAlerts }
